import React, { useEffect, useState } from 'react';
import styles from './ConfirmSampleDataPage.module.css';
import Header from '../../components/Header/Header';
import { Spinner, Row, Col, Button } from "react-bootstrap";
import { InfoCircleFill, Download } from "react-bootstrap-icons";
import * as apiSupplierOnboard from '../../apis/supplierOnboard';
import confirmationLogo from '../../icons/confirmation-success.svg';
import moment from "moment";
import 'moment/locale/id';

const ConfirmSampleDataPage = () => {
    const [sample, setSample] = useState();
    const [isLoading, setIsLoading] = useState();

    useEffect(() => {
        let subs = window.location.pathname.split("/");

        const fetchData = async () => {
            setIsLoading(true);
            const samplePromise = apiSupplierOnboard.getSampleById({sampleId: subs.pop()});
            const [sampleResponse] = await Promise.all([samplePromise]);
            setSample(sampleResponse.data.data);
            setIsLoading(false);
        }
        fetchData().catch(console.error);
    }, [])

    const copyRegistrationCode = async () => {
        const copied = await navigator.clipboard.writeText(sample.supplierOnboardResponse.registrationCode)
            .then(() => {
                alert("Kode registrasi " + sample.supplierOnboardResponse.registrationCode + " berhasil disalin.")})
            .catch(() => {
                alert("Error");
             });
        console.log(copied);
    }

    return <div className={styles.container}>
        <Header activeKey="/" />
        <div className={styles.pageBody}>
            {isLoading && 
                <Spinner className="mx-auto d-block"
                animation="border" size="lg" />
            }
            {!sample && !isLoading &&
            <Row>
                <Col lg={12}>
                    <div className={[styles.confirmationCard, styles.textArea]}>
                        <p>Data sample tidak ditemukan!</p>
                    </div>
                </Col>
            </Row>
            }
            {sample && !isLoading &&
            <Row>
                <Col lg={12}>
                    <div className={styles.confirmationCard}>
                        <div className={styles.iconArea}>
                            <img src={confirmationLogo}
                                alt={"Success"}
                                className={styles.iconImage}
                            />
                        </div>
                        <Row className='mt-4 justify-content-center'>
                            <div className={styles.textArea}>
                                <p>Selagi tim kami memproses verifikasi dokumen, Anda bisa lakukan pengiriman sampel sesuai dengan data yang sudah diajukan.</p>
                                <p className='m-0'>Tanggal Pengiriman Sampel:</p>
                                <p>
                                    <strong>{moment(sample.deliveryAt).format('dddd, D MMMM YYYY')}</strong>
                                </p>
                            </div>
                        </Row>
                        <Row className='mt-4 justify-content-center'>
                            <div className={styles.registrationCodeTextArea}>
                                <p className='m-0'>Kode Registrasi: <strong>{sample.supplierOnboardResponse.registrationCode}</strong></p>
                                <button onClick={() => {copyRegistrationCode(sample.supplierOnboardResponse.registrationCode)}} className='m-0'>Salin Kode</button>        
                            </div>
                        </Row>
                        <Row className='mt-4 justify-content-center'>
                            <div className={styles.textArea}>
                                <a target="_blank" href={process.env.REACT_APP_API_URL + "web/supplier-onboard/sample/" + sample.id + "/sample-document.pdf"}>
                                    <Button className={styles.btnOutlineGreen}>
                                        <span className="me-2"><Download /></span><span>Download Data Sampel</span>
                                    </Button>
                                </a>
                            </div>
                        </Row>
                        <Row className='mt-4 justify-content-center'>
                            <div className={styles.messageContainer}>
                                <div className={styles.messageIconArea}>
                                    <InfoCircleFill className={styles.messageIcon} />
                                </div>
                                <div className={styles.messageArea}>
                                    <h6>Alamat Warehouse Segari {sample.warehouse.name}</h6>
                                    <p className="mb-0">{sample.warehouse.address}</p>
                                </div>
                            </div>
                        </Row>
                        <Row className='mt-4 justify-content-center'>
                            <div className={styles.textArea}>
                                <p>Jika ada pertanyaan terkait proses registrasi silakan menghubungi kami melalu email <a href="mailto:handoyo@segari.id">handoyo@segari.id</a></p>
                            </div>
                        </Row>
                    </div>
                </Col>
            </Row>
            }
        </div>
    </div>
}

export default ConfirmSampleDataPage;